import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import { updateTaskSchema } from "@backend/src/schemas/taskSchema";
import ApiRequest from "../ApiRequest";
import { Task } from "./useTaskCreateMutation";
import { invalidateTaskRelatedQueries } from "@/utils/cacheInvalidation";

type UpdateTaskResponseType = ResponseType<Task>;

function useUpdateTaskMutation(taskId?: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<UpdateTaskResponseType>["response"],
    AxiosResponseAndError<UpdateTaskResponseType>["error"],
    z.infer<typeof updateTaskSchema> & { id?: string }
  >({
    mutationFn: (data) => {
      const id = data.id ? data.id : taskId;
      delete data.id;
      return ApiRequest.put<UpdateTaskResponseType>(
        requestURLs.task + id,
        data
      );
    },
    onSuccess: (res, variables) => {
      const targetTaskId = res?.data?.data?.taskId || variables.id || taskId;
      const targetProjectId = res?.data?.data?.projectId;
      void invalidateTaskRelatedQueries(queryClient, {
        taskId: targetTaskId,
        projectId: targetProjectId,
      });
    },
  });

  return mutation;
}

export default useUpdateTaskMutation;
